const apiEndpointsMap = {
  // Phase-1
  "C++ Basics": "cpp-basics",
  "C++ STL": "cpp-stl",
  "Basic Maths": "basic-maths",
  "Basic Number theory": "basic-number-theory",
  "Geometry for Beginners": "geometry-for-beginners",
  "Basic ADHOC": "basic-adhoc",
  "Codeforces A grind": "a-grind",

  // Phase-2
  "Basic Recursion": "basic-recursion",
  "Binary Search STL": "binary-search-stl",
  Greedy: "greedy",
  "Constructive Algorithms": "constructive-algorithms",
  "Game Theory": "game-theory",
  "1D Prefix Sum": "one-d-prefix-sum",
  Backtracking: "backtracking",
  "Bit Manipulation": "bit-manipulation",
  "Codeforces B Grind": "b-grind",

  // Phase-3
  "Greedy Advanced": "greedy-advanced",
  "Binary Search on Answer": "binary-search-on-answer",
  "Custom Sorting": "custom-sorting",
  Bitmasking: "bitmasking",
  "Moderate Number Theory": "moderate-number-theory",
  "Modular Arithmetic": "modular-arithmetic",
  "Sliding Window": "sliding-window",
  "2-Pointers": "two-pointers",
  "Codeforces C grind": "c-grind",

  // Phase-4
  "2D Prefix Sum & Difference Array": "two-d-prefix-sum-and-difference-array",
  "Basic Trees/ DFS": "basic-trees-dfs",
  BFS: "bfs",
  Djikstra: "djikstra",
  DSU: "dsu",
  "Directed Graphs": "directed-graphs",
  MST: "mst",
  "Interactive Problems": "interactive-problems",
  "Introductory DP": "introductory-dp",
  "Grid DP": "grid-dp",
  "LIS DP": "lis-dp",
  "Knapsack DP": "knapsack-dp",
  "Segment Tree": "segment-tree",
  "Advanced Number Theory": "advanced-number-theory",
  Combinatorics: "combinatorics",
  "Basic Probability": "basic-probability",
  "Inclusion Exclusion": "inclusion-exclusion",
  Stacks: "stacks",
  Tries: "tries",
  "Suffix Array": "suffix-array",
  "Codeforces D grind": "d-grind",

  // Phase-5
  "Small to Large Merging": "small-to-large-merging",
  "Binary Lifting": "binary-lifting",
  "DP on Trees": "dp-on-trees",
  "Re-rooting": "re-rooting",
  "Euler Tour": "euler-tour",
  "Heavy Light Decomposition": "heavy-light-decomposition",
  "Centroid Decomposition": "centroid-decomposition",
  "Topological Sort": "topological-sort",
  "DP on DAG": "dp-on-dag",
  "Tarjan's Algorithm": "tarjan's-algorithm",
  "0-1 BFS": "zero-one-bfs",
  SCC: "scc",
  "Eppstein's Algorithm": "eppstein's-algorithm",
  "Bellman Ford Algorithm": "bellman-ford-algorithm",
  "Floyd Warshal Algorithm": "floyd-warshal-algorithm",
  "Bitmask DP": "bitmask-dp",
  "Digit DP": "digit-dp",
  "Combinatorial DP": "combinatorial-dp",
  "Range DP": "range-dp",
  "Matrix Exponentiation": "matrix-exponentiation",
  "Markov Chains": "markov-chains",
  "Randomized Algorithm": "randomized-algorithm",
  "Fenwick Trees": "fenwick-trees",
  "Lazy Propagation": "lazy-propagation",
  "Square Root Decomposition": "square-root-decomposition",
  PBDS: "pbds",
  "Sparse Table": "sparse-table",
  "Mo's Algorithm": "mo's-algorithm",
  "Advanced Game Theory": "advanced-game-theory",
  "Z Algorithm": "z-algorithm",
  KMP: "kmp",
  "String Suffix Structure": "string-suffix-structure",

  // Phase-6
  "State Optimization": "state-optimization",
  "Convex Hull": "convex-hull",
  "SOS DP": "sos-dp",
  "Divide and Conquer": "divide-and-conquer",
  "Li Chao Tree": "li-chao-tree",
  "Slope Trick": "slope-trick",
  "DP on Broken Profile": "dp-on-broken-profile",
  "Plug DP": "plug-dp",
  "Segment Tree Optimization": "segment-tree-optimization",
  "1D1D Optimization": "one-done-d-optimization",
  "Knuth's Optimization": "knuth's-optimization",
  Flows: "flows",
  "Meet in the Middle": "meet-in-the-middle",
  "Chinese Remainder Theorem": "chinese-remainder-theorem",
  FFT: "fft",
  "Generating Functions": "generating-functions",
  NTT: "ntt",
  "XOR Basis": "xor-basis",
  BCC: "bcc",
  "2CC": "2cc",
  "Link Cut Trees": "link-cut-trees",
  "Offline Deletion": "offline-deletion",
  "2-Sat": "two-sat",
  Treaps: "treaps",
  "Virtual Tree": "virtual-tree",
  "Dynamic Segment Trees": "dynamic-segment-trees",
  "Persistance Segment Trees": "persistance-segment-trees",
  "Wavelet Trees": "wavelet-trees",
};

const PLATFORM_OPTIONS = [
  "CodeForces",
  "Geeks for Geeks",
  "Codechef",
  "Leetcode",
  "Atcoder",
  "Cses",
];

export { apiEndpointsMap, PLATFORM_OPTIONS };
